import { AppnebulaTaboolaEventName, TaboolaPaymentData } from '../../entities';
import { AppnebulaTaboolaService, TaboolaService } from '../../interfaces';

export class AppnebulaHttpTaboolaService implements AppnebulaTaboolaService {
  constructor(private readonly taboolaService: TaboolaService) {}

  signUp() {
    return this.taboolaService.track(AppnebulaTaboolaEventName.SIGN_UP);
  }

  purchase({ currency, ltvPredict, orderId }: TaboolaPaymentData) {
    return this.taboolaService.track(AppnebulaTaboolaEventName.PURCHASE, {
      currency,
      revenue: ltvPredict,
      orderid: orderId,
    });
  }

  scanView() {
    return this.taboolaService.track(AppnebulaTaboolaEventName.SCAN_VIEW);
  }
}
